<template>
  <v-dialog
    :modelValue="dialog"
    @click:outside="$emit('updateDialog')"
    @keydown.esc="$emit('updateDialog')"
    :max-width="$vuetify.display.mdAndDown ? undefined : '750px'"
    :scrim="!$vuetify.display.mdAndDown"
    :fullscreen="$vuetify.display.mdAndDown"
  >
    <v-card
      :class="$vuetify.display.mdAndDown ? 'h-100 d-flex flex-column' : ''"
    >
      <v-card-title class="title-modal">
        <span class="headline">DETALLE ASN</span>
      </v-card-title>

      <v-card-text
        :class="$vuetify.display.mdAndDown ? 'flex-grow-1 overflow-auto' : ''"
      >
        <v-container fluid class="mt-0 mb-0">
          <v-row justify="center">
            <v-col :cols="$vuetify.display.smAndDown ? 12 : 12">
              <v-form ref="form">
                <v-combobox
                  v-model="item.product"
                  name="product"
                  item-title="label"
                  item-value="id"
                  :items="products"
                  label="Producto*"
                  autocomplete="off"
                  :rules="[rules.requiredComboBox]"
                  clearable
                  @update:modelValue="loadQualities"
                ></v-combobox>

                <!-- validar numerico  -->
                <v-text-field
                  autocomplete="off"
                  name="expected_amount"
                  label="Cantidad Esperada*"
                  type="text"
                  v-model="item.expected_amount"
                  :rules="[rules.required]"
                />
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions
        class="pa-4"
        :class="$vuetify.display.mdAndDown ? 'flex-shrink-0' : ''"
      >
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          :variant="'text'"
          @click="$emit('updateDialog')"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green"
          :variant="'text'"
          @click="addNewProduct()"
          :class="$vuetify.display.mdAndDown ? 'px-6 ml-3' : ''"
        >
          {{ itemEdit != null ? "Editar" : "Agregar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { productoService } from "@/libs/ws/productoService";
import { productQualityService } from "@/libs/ws/productQualityService";
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  created() {},
  mixins: [ValidMixin],
  components: {},
  props: {
    dialog: Boolean,
    asn: Object,
    updateDialog: Function,
    addProduct: Function,
    itemEdit: Object,
  },
  data: () => ({
    item: {
      lpn: "",
      product: null,
      expected_amount: null,
      expected_manufacture_date: null,
      expected_expiration_date: null,
      expected_lote: null,
      expected_serie: null,
      expected_quality: null,
      expected_storage_units_amount: null,
      external_line_number: "",
    },
    defaultItem: null,
    presentation_products: [],
    products: [],
    qualities: [],
  }),
  watch: {
    dialog() {
      if (this.itemEdit == null) {
        this.item = JSON.parse(JSON.stringify(this.defaultItem));
      } else {
        this.item = JSON.parse(JSON.stringify(this.itemEdit));
      }
    },
  },
  mounted() {
    this.loadProducts();
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    loadProducts() {
      let client = this.asn.client != null ? this.asn.client.id : null;
      productoService.filter({ client: client }).then((response) => {
        this.products = response.result.list;
      });
    },
    loadQualities() {
      if (this.item.product == null) {
        return;
      }

      productQualityService
        .filter({ product: this.item.product.id })
        .then((response) => {
          this.qualities = response.result.list;
        });
    },
    async addNewProduct() {
      const { valid } = await this.$refs.form.validate();
      if (valid) {
        this.$emit("addProduct", this.item);
      }
    },
  },
};
</script>
